import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { EditRubricComposableSection } from 'apps/sigma2-ui/src/components/rubrics/EditRubricComposableSection';
import { RubricGradingType } from 'libs/end-to-end/src/types/rubrics/rubric';

export const EditRubricAddCategoryStrippedSection: React.FC<{
  gradingType: RubricGradingType;
  onCategoryCreate: () => void;
  onCategorySelect: () => void;
  isReadOnlyMode: boolean;
}> = ({ gradingType, onCategoryCreate, onCategorySelect, isReadOnlyMode }) => {
  const language = useLanguage();

  if (isReadOnlyMode) {
    return null;
  }

  return (
    <EditRubricComposableSection
      heading={language.editRubricAddCategoryStrippedSectionHeading({
        gradingType,
      })}
      onCreate={onCategoryCreate}
      onSelect={onCategorySelect}
      isReadOnlyMode={isReadOnlyMode}
    />
  );
};
